import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addSpaceAfterComma'
})
export class AddSpaceAfterCommaPipe implements PipeTransform {

  transform(value: any): string {
   if (value == null || value ==='') {
    return '';
   }
   
    return String(value).replace(/,/g,', ');
  }
}
